import { render, staticRenderFns } from "./EditableComponent.vue?vue&type=template&id=88d06b78&scoped=true"
import script from "./EditableComponent.vue?vue&type=script&lang=js"
export * from "./EditableComponent.vue?vue&type=script&lang=js"
import style0 from "./EditableComponent.vue?vue&type=style&index=0&id=88d06b78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d06b78",
  null
  
)

export default component.exports